import React from 'react';
import { ViewMode } from 'gantt-task-react';
import {
  Button,
  Stack,
  Typography,
  Switch,
  FormControlLabel,
  Paper
} from '@mui/material';

export const ViewSwitcher = ({ isChecked, onViewListChange, onViewModeChange }) => {
  return (
    <Paper elevation={ 2 } sx={ { p: 2, mb: 2 } }>
      <Stack spacing={ 2 }>
        {/* <Typography variant="h6">Select View Mode</Typography> */ }

        <Stack direction="row" spacing={ 1 } flexWrap="wrap">
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.Hour) }>
            Hour
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.QuarterDay) }>
            Quarter Day
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.HalfDay) }>
            Half Day
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.Day) }>
            Day
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.Week) }>
            Week
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.Month) }>
            Month
          </Button>
          <Button variant="outlined" onClick={ () => onViewModeChange(ViewMode.Year) }>
            Year
          </Button>
        </Stack>

        <FormControlLabel
          control={
            <Switch
              checked={ isChecked }
              onChange={ (e) => onViewListChange(e.target.checked) }
              color="primary"
            />
          }
          label="Show Task List"
        />
      </Stack>
    </Paper>
  );
};
